<script lang="ts" setup>
  import { computed } from 'vue'
  import { useAppLanguage } from '@/composables/useAppLanguage.ts'
  import { type AvailableLocals } from '@/plugins/i18n.ts'

  const appLanguage = useAppLanguage()

  const changeLanguage = () => {
    const nextLang = appLanguage.current.value === 'en' ? 'ar' : 'en'
    appLanguage.updateLocale(nextLang as AvailableLocals)
  }

  const nextLanguageName = computed(() =>
    appLanguage.current.value === 'en' ? 'عربي' : 'EN'
  )
</script>

<template>
  <div>
    <v-btn
      block
      class="border border-opacity-50 pa-2"
      :ripple="false"
      variant="text"
      @click="changeLanguage"
    >
      <span>
        {{ nextLanguageName }}
      </span>
    </v-btn>
  </div>
</template>


<style scoped>
:deep(.v-btn__overlay) {
  opacity: 0 !important;
}

.v-btn {
  --v-hover-opacity: 0;
}
</style>
